import React, { useEffect, useState } from "react";
import IMAGES from "constants/images";
import { Badge, Image, Form, Card, Col, Row, Button } from "react-bootstrap";
import RatingStars from "components/RatingStars";
import { Icon } from "@iconify/react";
import { popularMentions } from "api/ProductService";

import { useUserRole } from "services/provider";
import { useAuth } from "context/UserContext";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { Sentry, Spinner } from "react-activity";
import Loader from "components/Loader";

const StepOneComponent = ({
  selectedProducts,
  selectedSoftware,
  setSelectedSoftware,
  handleSelect,
  checkedProducts,
  step,
  handleNext,
  handleRemoveCheckedProduct,
  searchText,
  setSearchText,
  productLoading,
  // setCheckedProducts,
}) => {
  const navigate = useNavigate();
  const [mentions, setMentions] = useState([]);
  const [totalItems, setTotalItems] = useState(0);
  const [page, setPage] = useState(1);
  const limit = 10;
  const { isLoggedIn, user } = useAuth();
  const [modalType, setModalType] = useState(isLoggedIn ? "" : "login");
  const { role } = useUserRole();


  const fetchMentions = async () => {
    try {
      const res = await popularMentions({ page, limit });
      if (res.success) {
        // setProducts(res.body.data); // set current page data onl
        const optimiseData =
          res.body?.data?.map((v) => ({ label: v?.title, value: v?._id })) ||
          [];
        setMentions(optimiseData);
        setTotalItems(res.body.total); // total number of items
      }
    } catch (err) {
      console.error("Failed to fetch pouplar mentions", err);
    }
  };
  useEffect(() => {
    fetchMentions();
  }, [page]);
  return (
    <>
      <div>
        <h2>Search for tools to power your workplace.</h2>
        <p>
          If you're researching new business software or services, you know how
          helpful reviews from real people can be. Our community is a place for
          professionals to help one another find the best business solutions.
        </p>
        <div className="searchMentions">
          <div className="searchInput">
            <Image src={IMAGES.Search_Normal} alt="search" />
            <Form.Control
              placeholder="Search software or services you want to review..."
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
            />
          </div>
          <h6>Popular Categories</h6>
          <div className="d-flex flex-wrap gap-2 ">
            {[
              {
                label: "All Categories",
                value: "all",
              },
            ]
              .concat(mentions)
              ?.map((mention, index) => (
                <Badge
                  key={index}
                  pill
                  bg={
                    mention.value === selectedSoftware.value
                      ? "danger"
                      : "white"
                  }
                  text={
                    mention.value === selectedSoftware.value ? "white" : "dark"
                  }
                  className="p-2"
                  onClick={() => setSelectedSoftware(mention)}
                  style={{ cursor: "pointer" }}
                >
                  {mention.label}
                </Badge>
              ))}
          </div>
        </div>
        <div className="categories_section categories_section_cus mt35 write_review">
          <Row>
            {productLoading ? (
              <div className="d-flex justify-content-center align-items-center" style={{height: '42vh'}}>
                <Sentry color="#e91515" size={40} speed={1} animating={true} />
                {/* <Loader  style={{width: 100, height: 100}} /> */}
              </div>
            ) : selectedProducts?.length > 0 ? selectedProducts?.map(
              (
                product,
                idx // ✅ Updated to selectedProducts
              ) => {
                return (
                  <Col xs={6} sm={6} md={6} lg={4} key={idx} className="mb-3">
                    <Card style={{height: '80%'}}>
                      <Card.Body
                        className="position-relative"
                        onClick={() => handleSelect(product?.id)}
                        style={{ cursor: 'pointer' }}
                      >
                        <div
                          className="iconBox"
                          style={{
                            backgroundColor: product.brandColors,
                          }}
                        >
                          <img
                            src={product?.logoUrl}
                            alt={product?.name}
                            style={{ width: 40, height: 40,objectFit:"contain" }}
                          />
                        </div>
                        <Form.Check
                          type="checkbox"
                          id={`compare-${product?.id}`}
                          name="compare"
                          className="comparepos1"
                          checked={[product?.id]?.includes(
                            checkedProducts[0]?.id
                          )}
                          onChange={() => handleSelect(product?.id)}
                        />
                        <Card.Title className="mb-1">
                          {product?.name}
                        </Card.Title>
                        <Card.Text>
                          <RatingStars rating={product?.avgRating} />{" "}
                          <strong>({product?.totalReviews})</strong>
                        </Card.Text>
                      </Card.Body>
                    </Card>
                  </Col>
                );
              }
            ) : (
              <Col lg={12} className="text-center">
                <h5>No products found</h5>
              </Col>
            )}
          </Row>
        </div>
      </div>
      <div className="d-flex justify-content-between mt-4 ">
        {step === 1 &&
          checkedProducts?.length > 0 &&
          checkedProducts?.map((v) => {
            return (
              <div className="d-flex flex-wrap  gap-3 align-items-center w-100" key={v.id}>
                <div
                  className="position-relative proBox"
                  style={{
                    backgroundColor: "#FFDDE2",
                  }}
                >
                  <div className="closeBtn">
                    <button
                      className="btn-close"
                      onClick={() => handleRemoveCheckedProduct(v.id)}
                    >
                      <Icon icon="basil:cross-solid" fontSize={20} />
                    </button>
                  </div>
                  <img
                    src={v.logoUrl}
                    alt=""
                    style={{ width: 40, height: 40,objectFit:"contain" }}
                  />
                </div>
                <h5 className="mb-0 w-100">{v.name}</h5>
              </div>
            );
          })}
        <div className="text-end w-100">
          <Button
            disabled={checkedProducts.length === 0}
            variant="info"
            onClick={() => {
              if (isLoggedIn) {
                localStorage.setItem(
                  "checkedProducts",
                  JSON.stringify(checkedProducts)
                );

                handleNext();
              } else {
                toast.error("Please login first!.");
              }
            }}
            className="border-radius-100 px-5"
          >
            {step === 4 ? "Submit" : "Continue"}
          </Button>
        </div>
      </div>
    </>
  );
};

export default StepOneComponent;
